<template>
  <div class="row">
    <div
      class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pb-0 check-text-center"
    >
      <h6 class="mb-0 worksansr">
        FORMULÁRIO:
        <strong>{{ semiology_form ? semiology_form.name : "" }}</strong>
      </h6>
      <p class="m-0 worksansr">
        DESCRIÇÃO: {{ semiology_form ? semiology_form.description : "" }}
      </p>
      <h4 class="m-0">
        {{ current_resident ? `RESIDENTE: ${current_resident.name}` : "" }}
      </h4>
    </div>
    <div
      class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pb-0 check-text-right"
    >
      <confirmation-dialog
        v-if="residents.length > 1"
        :disabled="loading"
        message-title="PULAR RESIDENTE?"
        message-body="Não é possível retornar."
        open-text="PULAR RESIDENTE"
        open-class="btn-acess ml-2"
        header-class="modal-header-i"
        yesClass="btn-i worksansr"
        openRightIcon="fa-arrow-right ml-2"
        @yes="evOnFormNext"
      />
    </div>
    <div
      class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0 pb-0"
      v-if="current_resident_index < residents.length"
    >
      <form-with-props
        :semiology_form="semiology_form"
        :resident="current_resident"
        :current="current_resident_index"
        :total="residents.length"
        @anwered="evOnFormAnswered"
        @return="emitReturn"
      />
    </div>
  </div>
</template>

<script>
import toast from "../../lib/ToastNotification";
import ConfirmationDialog from "../Components/ConfirmationDialog.vue";
import FormWithProps from "../Resident/Semiology/FormWithProps.vue";

export default {
  name: "AnswerSemiology",
  components: { FormWithProps, ConfirmationDialog },
  props: {
    semiology_form: [Object, undefined],
    residents: [Array, undefined],
  },
  data() {
    return {
      errors: [],
      loading: false,

      answered_ids: [],
      current_resident: undefined,
      current_resident_index: 0,
    };
  },
  watch: {
    residents: function () {
      this.answered_ids = [];
      this.current_resident_index = 0;
      this.current_resident = this.residents[this.current_resident_index];
    },
  },
  created() {
    this.answered_ids = [];
    this.current_resident_index = 0;
    this.current_resident = this.residents[this.current_resident_index];
  },
  methods: {
    async evOnFormAnswered() {
      await this.evOnFormNext(true);
    },

    async evOnFormNext(answered = false) {
      if (answered) this.answered_ids.push(this.current_resident.id);
      else toast("RESIDENTE PULADO", "success");

      if (this.current_resident_index < this.residents.length - 1) {
        this.current_resident_index++;
        this.current_resident = this.residents[this.current_resident_index];
      } else {
        await this.emitReturn();
      }
    },

    async emitReturn() {
      this.$emit("return", {
        form_name: this.semiology_form.name,
        form_description: this.semiology_form.description,
        residents: this.residents.map((resident) => ({
          ...resident,
          answered: this.answered_ids.includes(resident.id),
        })),
      });
    },
  },
};
</script>

<style>
</style>